import axios from "axios";  
import { BASE_URL } from "../../assets/constants";
import { createHeaders } from "../../utils/Utils";

//! Admin Login
//  Admin Login
export const adminLoginAPI = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}login`, data,headers);
};